<template>
  <div class="lotteryPanel">
    <div class="broadcast" v-if="winnerList.length > 0 && isShowBroadcast">
      <Rolling clipTime="2000">
        <div class="broadcastItem" v-for="item in winnerList" :key="item.id">
          {{ item.content }}
        </div>
      </Rolling>
    </div>
    <div class="leftChanceNote" v-if="isShowLeftChance">
      <i18n path="lottery_chance_note" tag="span">
        <span class="chanceHighlight">{{ lotteryTicketCount }}</span>
      </i18n>
    </div>
    <component
      :is="lotteryComponentRef"
      :lotterySetting="$attrs"
      :lotteryAwards="actData.rewards"
      :lotteryResult="lotteryResult"
      @fire="handleDraw"
      @lotteryFinish="handleLotteryFinish"
      @noTicket="handleNoTicket"
      @reportEvent="handleReport"
      :lotteryTicketCount="lotteryTicketCount"
    ></component>
    <WinModal
      :visible="isShowWinModal"
      :awardData="resultAwardsData"
      @reportEvent="handleReport"
      @close="handleCloseWinModal"
    ></WinModal>
    <NoPrizeModal
      :visible="isShowNoPrizeModal"
      @reportEvent="handleReport"
      @close="handleCloseNoPrizeModal"
    ></NoPrizeModal>
  </div>
</template>

<script>
import Rolling from '@/components/UI/Rolling';
import WinModal from './WinModal';
import NoPrizeModal from './NoPrizeModal';
import { lotteryComponents } from './ComponentsBook';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  components: { Rolling, WinModal, NoPrizeModal },
  props: {
    componentTypeId: Number,
    moduleName: String,
    toastText: String,
    isShowBroadcast: {
      type: Boolean,
      default: true
    },
    isShowLeftChance: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      },
      tplData: function(state) {
        return state[this.moduleName].tplData;
      },
      isShowWinModal: function(state) {
        return state[this.moduleName].isShowWinModal;
      },
      isShowNoPrizeModal: function(state) {
        return state[this.moduleName].isShowNoPrizeModal;
      },
      lotteryResult: function(state) {
        return state[this.moduleName].lotteryResult;
      }
    }),
    winnerList() {
      return this.actData && this.actData.message ? this.actData.message : [];
    },
    lotteryTicketCount() {
      return this.actData.remainTimes;
    },
    resultAwardsData() {
      if (this.lotteryResult && this.lotteryResult.length) {
        const award = this.lotteryResult[0];
        if (award.rewardType === 'REWARD_PACKAGE') {
          return {
            name: award.rewardName,
            awards: award.parsedUserRewardInfos
          };
        }
        return {
          name: award.detail && award.detail.title,
          awards: [award]
        };
      }
      return {};
    },
    lotteryComponentRef() {
      const componentRef = lotteryComponents[this.componentTypeId];
      if (!componentRef) {
        throw new Error(`组件不存在 ${this.componentTypeId}`);
      }
      return componentRef;
    }
  },
  methods: {
    ...mapActions('app', {
      submitDraw: function(dispatch) {
        dispatch(`${this.moduleName}/submitDraw`);
      },
      showLotteryResult: function(dispatch) {
        dispatch(`${this.moduleName}/showLotteryResult`);
      }
    }),
    ...mapMutations('app', {
      toggleWinModal: function(commit, ...props) {
        commit(`${this.moduleName}/toggleWinModal`, ...props);
      },
      toggleNoPrizeModal: function(commit, ...props) {
        commit(`${this.moduleName}/toggleNoPrizeModal`, ...props);
      },
      resetLotteryResult: function(commit) {
        commit(`${this.moduleName}/resetLotteryResult`);
      }
    }),
    handleDraw() {
      this.submitDraw();
    },
    handleLotteryFinish() {
      this.showLotteryResult();
    },
    handleCloseWinModal() {
      this.toggleWinModal(false);
      this.resetLotteryResult();
    },
    handleCloseNoPrizeModal() {
      this.toggleNoPrizeModal(false);
      this.resetLotteryResult();
    },
    handleNoTicket() {
      this.$hll.toast(this.toastText || '没有抽奖机会了');
    },
    handleReport(data) {
      this.$emit('reportEvent', data);
    }
  }
};
</script>

<style lang="less" scoped>
.lotteryPanel {
  position: relative;
  overflow: visible;
  text-align: center;

  .broadcast {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 24px;
    color: #fff;

    .broadcastItem {
      width: 550px;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .leftChanceNote {
    position: absolute;
    top: 105px;
    left: 50%;
    transform: translateX(-50%);
    width: 450px;
    font-size: 28px;
    color: #333;
    line-height: 1;

    .chanceHighlight {
      color: #ff0b0b;
    }
  }
}
</style>
